<template>
  <div v-if="dates.length">
    <h2
      class="mb-4 font-roboto text-[32px] font-medium leading-[38px] text-new-test-black"
    >
      Другие события в этот день
    </h2>
    <div class="relative mx-4">
      <DatesCardSlider
        :data="dates"
        :options="swiperDatesOptions"
        @on-swiper="onSwiper"
      />

      <SlidersSliderControl
        type="prev"
        class="absolute left-[-16px] top-35% z-10 hidden md:block"
        :class="isBeginning ? 'opacity-50' : 'cursor-pointer'"
        @click="slidePrev()"
      />
      <SlidersSliderControl
        type="next"
        class="absolute right-[-16px] top-35% z-10 hidden md:block"
        :class="isEnd ? 'opacity-50' : 'cursor-pointer'"
        @click="slideNext()"
      />
    </div>
  </div>
</template>

<script setup>
import 'swiper/css';

const props = defineProps({
  date: {
    type: String,
    default: new Date().toISOString().slice(0, 10),
  },
  current: {
    type: Number,
    default: null,
  },
});

const swiperDatesOptions = reactive({
  spaceBetween: 16,
  breakpoints: {
    768: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 3,
    },
    1536: {
      slidesPerView: 4,
    },
  },
});

const { onSwiper, slideNext, slidePrev, isEnd, isBeginning } = useSwiper();

const days = computed(() => {
  const dateString = props.date;
  const parts = dateString?.split('.');

  return {
    start_day: parts[0],
    start_month: Number(parts[1]),
    end_day: parts[0],
    end_month: Number(parts[1]),
  };
});

const filters = computed(() => {
  return {
    ...days.value,
  };
});

const { dateArticles } = useDateArticles({ filters, per_page: 15 });

const dates = computed(
  () =>
    dateArticles?.data?.value?.data?.filter((d) => d.id !== props.current) ||
    [],
);
</script>

<style lang="scss" scoped>
.swiper-button-prev,
.swiper-button-next {
  @apply hidden lg:block;
}
</style>
